angular.module("app").controller("GameReleasePageController", [
    '$scope',
    'pagination',
    'releaseJobStatuses',
    '$timeout',
    'casinoJobService',
    'errorHandler',
    'logger',
    'preloadedData',
    'settingsService',
    '$uibModal',
    'userStorage',
    function ($scope, pagination, releaseJobStatuses, $timeout, casinoJobService, errorHandler, logger, preloadedData, settingsService, $modal, userStorage) {
        var pendingListRequest;
        var firstLoad = true;
        const pending = 1;
        const readyForRelease = 20;

        $scope.filterOptions = {
            status: readyForRelease,
            search: "",
            searchByExternalId: "",
        };
        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.casinoGameJobs = angular.copy(preloadedData.casinoGameJobs).map(extractCasinoGameJob);

        $scope.multiSelect = {};
        $scope.multiSelect.statuses = releaseJobStatuses;
        $scope.multiSelect.selectedStatuses = [readyForRelease];
        // $scope.multiSelect.selectedStatuses = [];

        $scope.pagination = pagination.init(function (resetPage) {

            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData =  getFiltersValues();
                resetPage === true && (requestData.current_page = 1);
                if (!firstLoad) {
                    updateList(requestData)
                }

                firstLoad = false;
            }, 300);
        }, parseInt(preloadedData.total_count), 25);

        $scope.cancel = function (row) {
            let modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmAction.html",
                controller: "ConfirmModalController",
                resolve: {
                    text: function () {
                        return "templates.modals.confirmCancelReleaseAction"
                    }
                }
            });
            modalInstance.result.then(
                function (value) {
                    casinoJobService.cancel({id: row.job_id}).then(
                        function (response) {
                            if (response.status === "ok") {
                                logger.logSuccess("global.successfullyUpdated");
                                updateList(getFiltersValues())
                            } else {
                                errorHandler(response.message);
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                        }
                    )
                }
            );
        };
        $scope.startRelease = function (row) {
            let modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmAction.html",
                controller: "ConfirmModalController",
                resolve: {
                    text: function () {
                        return "templates.modals.confirmStartReleaseAction"
                    }
                }
            });
            modalInstance.result.then(
                function (value) {
                    casinoJobService.startRelease({id: row.job_id}).then(
                        function (response) {
                            if (response.status === "ok") {
                                logger.logSuccess("global.successfullyUpdated");
                                updateList(getFiltersValues())
                            } else {
                                errorHandler(response.message);
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                        }
                    )
                }
            );
        };
        $scope.openSkinJobModal = function (row) {
            $modal.open({
                templateUrl: "views/gameReleases/skinJobModal.html",
                controller: "GameReleaseEditPageController",
                resolve: {
                    gameName: function () {
                        return row.name;
                    },
                    gameId: function () {
                        return row.game_id;
                    },
                    casinoSkinGameJobs: function (casinoJobService, errorHandler) {
                        return casinoJobService.getSkinJobReleaseList({game_id: row.game_id}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.casinoSkinGameJobs)
                                } else {
                                    errorHandler(response.message);
                                    return []
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return []
                            }
                        )
                    },
                    groups: function(casinoGroupService) {
                        return casinoGroupService.get().then(function (data) {
                            return angular.copy(data.casinoGroups);
                        },function (response) {
                            return [];
                        });
                    }
                }
            })
        };

        $scope.openManageGroupsModal = function () {
            $modal.open({
                templateUrl: "views/gameReleases/manageSkinGroupModal.html",
                controller: "ManageSkinGroupController",
                resolve: {
                    skins: function(skinService) {
                        return skinService.getAllSkins().then(function (data) {
                            return angular.copy(data.skins);
                        },function (response) {
                            return [];
                        });
                    },
                    groups: function(casinoGroupService) {
                        return casinoGroupService.get().then(function (data) {
                            return angular.copy(data.casinoGroups);
                        },function (response) {
                            return [];
                        });
                    }
                }
            })
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.pagination.changePage()
        };

        function updateList(requestOptions) {
            settingsService.setFilters(requestOptions);
            casinoJobService.getJobReleaseList(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.casinoGameJobs = angular.copy(response.casinoGameJobs).map(extractCasinoGameJob);
                        $scope.pagination.totalItems = response.total_count;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        function getFiltersValues() {
            var currentFilters = {};
            currentFilters = {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
            };

            if ($scope.multiSelect.selectedStatuses){
                currentFilters.status = $scope.multiSelect.selectedStatuses
            }

            if ($scope.filterOptions.search){
                currentFilters.search = $scope.filterOptions.search
            }

            if ($scope.filterOptions.searchByExternalId){
                currentFilters.external_id = $scope.filterOptions.searchByExternalId
            }

            return currentFilters
        }

        function extractCasinoGameJob(casinoGameJob) {
            const rowStatus = parseInt(casinoGameJob.status);
            const foundStatus = releaseJobStatuses.find(status => status.value === rowStatus);
            const statusTitle = foundStatus ? foundStatus.title : 'Preparing For Release';

            return {
                job_id: casinoGameJob.id,
                id: casinoGameJob.extearnal_game_id,
                game_id: casinoGameJob.game_id,
                name: casinoGameJob.name,
                image: casinoGameJob.image,
                device: casinoGameJob.is_mobile == 1 ? 'Mobile' : 'Web',
                provider: casinoGameJob.provider,
                position: casinoGameJob.position,
                status: rowStatus,
                status_text: statusTitle,
                user: casinoGameJob.user,
                release_type: casinoGameJob.release_type == 2 ? {
                    value: 'Per Group',
                    tooltip: {
                        text: casinoGameJob.group_names
                    },
                } : 'All Skins',
                created_at: casinoGameJob.created_at,
            }
        }

        $scope.listFilterObject = {
            action: function () {
                updateList(getFiltersValues());
            }
        };
        $scope.tools = {};

        if (userStorage.getUserData().permissions.indexOf('manageAllGames') !== -1) {
            $scope.tools = {
                release: {
                    action: function (item) {
                        $scope.startRelease(item);
                    },
                    title: function () {
                        return 'Start Release'
                    },
                    class: function () {
                        return 'fa-rocket'
                    },
                    disabled: function (row) {
                        return row.status !== readyForRelease;
                    },
                },
                queue: {
                    action: function (item) {
                        $scope.openSkinJobModal(item);
                    },
                    title: function () {
                        return 'Skins Queue'
                    },
                    class: function () {
                        return 'fa-pencil-square-o'
                    },
                    disabled: function (row) {
                        return row.status !== readyForRelease;
                    },
                },
                cancel: {
                    action: function (item) {
                        $scope.cancel(item)
                    },
                    title: function () {
                        return 'Cancel'
                    },
                    class: function () {
                        return 'fa-ban'
                    },
                    disabled: function (row) {
                        return row.status !== readyForRelease && row.status !== pending;
                    },
                }
            };
        }

        $scope.ignoreColumns = {
            job_id: true,
            game_id: true,
            status: true
        }
    }
]);
